import { render, staticRenderFns } from "./ConfigCategoryForm.vue?vue&type=template&id=ef7b7834&scoped=true"
import script from "./ConfigCategoryForm.vue?vue&type=script&lang=js"
export * from "./ConfigCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigCategoryForm.vue?vue&type=style&index=0&id=ef7b7834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7b7834",
  null
  
)

export default component.exports